import { defineComponent as _defineComponent } from 'vue'
import { ModalWrapper } from '@/shared/ui/modals'
import { mdiClose } from '@mdi/js'
import { mediaApi, MediaDB } from '@/enitites/media'
import { computed, onMounted, ref } from 'vue'
import BKMediaEditor from './BKMediaEditor.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MediaPanel',
  props: {
    orgId: { default: 0 },
    eventId: { default: 0 },
    canEdit: { type: Boolean, default: false },
    title: { default: 'Media' }
  },
  setup(__props: any) {

const props = __props as { orgId: number, eventId: number, canEdit: boolean, title: string };



const media = ref<MediaDB[]>([])
const isShowMediaEditor = ref(false)
const isShowMediaPlayer = ref(false)
const selectedMedia = ref('')
const loadingDeleteMedia = ref(false)

const embedSourceUrl = computed(() => {
  return `https://www.youtube.com/embed/${selectedMedia.value}?autoplay=1`
})

async function fetchMedia() {
  const fetchedMedia = await mediaApi.getMedia({
    eventId: props.eventId,
    orgId: props.orgId,
  })

  if (fetchedMedia) media.value = fetchedMedia
}

function submitSaveMedia(updatedMedia: MediaDB[]) {
  media.value = updatedMedia
  isShowMediaEditor.value = false
}

function showMedia(link: string) {
  isShowMediaPlayer.value = true
  selectedMedia.value = link
}

async function removeMedia(id: number) {
  loadingDeleteMedia.value = true
  const mediaUpdated = await mediaApi.removeMedia(id)
  if (mediaUpdated) media.value = mediaUpdated
  loadingDeleteMedia.value = false
}

function getPreviewImageUrl(youtubeId: string) {
  return `https://img.youtube.com/vi/${youtubeId}/0.jpg`
}

onMounted(() => {
  fetchMedia()
})

return { __sfc: true,props, media, isShowMediaEditor, isShowMediaPlayer, selectedMedia, loadingDeleteMedia, embedSourceUrl, fetchMedia, submitSaveMedia, showMedia, removeMedia, getPreviewImageUrl, ModalWrapper, mdiClose, BKMediaEditor }
}

})